{
  "version": "feeling-experiences-0.1.0",
  "artwork": [
    {
      "image": "/assets/energized-story-01-dawn.webp",
      "alt": "Warm sunlight through linen curtains beside a pale oak table and cream chair. Original AI-generated fictional editorial illustration.",
      "credit": "myAudience · AI-generated story illustration",
      "license": "Generated for myAudience; fictional scene, not a documentary photograph"
    },
    {
      "image": "/assets/energized-story-02-ready-desk.webp",
      "alt": "Open blank notebook and pencil on a prepared pale oak desk in warm window light. Original AI-generated fictional editorial illustration.",
      "credit": "myAudience · AI-generated story illustration",
      "license": "Generated for myAudience; fictional scene, not a documentary photograph"
    },
    {
      "image": "/assets/energized-story-03-garden-path.webp",
      "alt": "Sunlit courtyard path with planted borders and an empty wooden chair beside it. Original AI-generated fictional editorial illustration.",
      "credit": "myAudience · AI-generated story illustration",
      "license": "Generated for myAudience; fictional scene, not a documentary photograph"
    },
    {
      "image": "/assets/energized-story-04-first-mark.webp",
      "alt": "Open notebook with one small abstract graphite stroke and a pencil on an oak desk. Original AI-generated fictional editorial illustration.",
      "credit": "myAudience · AI-generated story illustration",
      "license": "Generated for myAudience; fictional scene, not a documentary photograph"
    },
    {
      "image": "/assets/inspired-story-01-notice.webp",
      "alt": "Burgundy curved ceramic, lavender fabric and blue-green glass in soft studio light. Original AI-generated fictional editorial illustration.",
      "credit": "myAudience · AI-generated story illustration",
      "license": "Generated for myAudience; fictional scene, not a documentary photograph"
    },
    {
      "image": "/assets/inspired-story-02-imagine.webp",
      "alt": "Terracotta arch, translucent teal glass, lavender paper and a burgundy sphere on pale stone. Original AI-generated fictional editorial illustration.",
      "credit": "myAudience · AI-generated story illustration",
      "license": "Generated for myAudience; fictional scene, not a documentary photograph"
    },
    {
      "image": "/assets/inspired-story-03-connect.webp",
      "alt": "Creative studio desk with a blank sketchbook, pencil, teal vase and burgundy chair. Original AI-generated fictional editorial illustration.",
      "credit": "myAudience · AI-generated story illustration",
      "license": "Generated for myAudience; fictional scene, not a documentary photograph"
    },
    {
      "image": "/assets/inspired-story-04-keep.webp",
      "alt": "Small paper color study with burgundy, lilac and teal abstract paint shapes beside a brush. Original AI-generated fictional editorial illustration.",
      "credit": "myAudience · AI-generated story illustration",
      "license": "Generated for myAudience; fictional scene, not a documentary photograph"
    }
  ],
  "experiences": [
    {
      "activityId": "feeling-inspired-01",
      "mood": "inspired",
      "stages": [
        {
          "label": "Notice",
          "title": "Find the generous curve",
          "text": "Look at the broad burgundy curve beside the smaller glass. Which shape would you let take more space?",
          "image": "/assets/inspired-story-01-notice.webp",
          "durationMs": 12000
        },
        {
          "label": "Imagine",
          "title": "Make one shape larger",
          "text": "Imagine the arch or sphere enlarged until it becomes the centre of an arrangement. What would you leave small?",
          "image": "/assets/inspired-story-02-imagine.webp",
          "durationMs": 12000
        },
        {
          "label": "Connect",
          "title": "Give the idea a page",
          "text": "The studio sketchbook is open. Picture a single broad line on its page, with enough clear space around it.",
          "image": "/assets/inspired-story-03-connect.webp",
          "durationMs": 12000
        },
        {
          "label": "Keep",
          "title": "Keep one bold detail",
          "text": "The colour study gives burgundy the largest area. Choose one detail you would make generous in your own idea.",
          "image": "/assets/inspired-story-04-keep.webp",
          "durationMs": 12000
        }
      ]
    },
    {
      "activityId": "feeling-inspired-02",
      "mood": "inspired",
      "stages": [
        {
          "label": "Notice",
          "title": "Look beyond an imagined frame",
          "text": "Follow the edge of the curved ceramic. Imagine a frame around this scene: what might continue beyond it?",
          "image": "/assets/inspired-story-01-notice.webp",
          "durationMs": 12000
        },
        {
          "label": "Imagine",
          "title": "Invite a new neighbour",
          "text": "Terracotta, teal glass and lavender paper share the surface. Which material would you introduce to a blank wall as a colour or shape?",
          "image": "/assets/inspired-story-02-imagine.webp",
          "durationMs": 12000
        },
        {
          "label": "Connect",
          "title": "Try a colour in a small place",
          "text": "Picture your chosen colour on the open sketchbook page: a small swatch, a margin or one simple outline.",
          "image": "/assets/inspired-story-03-connect.webp",
          "durationMs": 12000
        },
        {
          "label": "Keep",
          "title": "Name your invitation",
          "text": "The study lets three colours meet without filling the whole page. Finish this thought: I would like to see more…",
          "image": "/assets/inspired-story-04-keep.webp",
          "durationMs": 12000
        }
      ]
    },
    {
      "activityId": "feeling-inspired-03",
      "mood": "inspired",
      "stages": [
        {
          "label": "Notice",
          "title": "Notice what the light reveals",
          "text": "Light catches the glass and burgundy glaze while the fabric stays softer. Which surface would you follow first?",
          "image": "/assets/inspired-story-01-notice.webp",
          "durationMs": 12000
        },
        {
          "label": "Imagine",
          "title": "Let a shadow change the idea",
          "text": "The teal glass changes the light behind it. Imagine moving this arrangement toward or away from a window.",
          "image": "/assets/inspired-story-02-imagine.webp",
          "durationMs": 12000
        },
        {
          "label": "Connect",
          "title": "Imagine another hour",
          "text": "Picture the studio desk at a different hour. What detail would you want to keep visible when the light changes?",
          "image": "/assets/inspired-story-03-connect.webp",
          "durationMs": 12000
        },
        {
          "label": "Keep",
          "title": "Keep a luminous detail",
          "text": "The pale paper leaves room around its colours. Name one luminous detail you might carry into a drawing or description.",
          "image": "/assets/inspired-story-04-keep.webp",
          "durationMs": 12000
        }
      ]
    },
    {
      "activityId": "feeling-inspired-04",
      "mood": "inspired",
      "stages": [
        {
          "label": "Notice",
          "title": "Find the space between objects",
          "text": "Look between the glass and the curved ceramic. Which patch of empty surface lets the objects stand apart?",
          "image": "/assets/inspired-story-01-notice.webp",
          "durationMs": 12000
        },
        {
          "label": "Imagine",
          "title": "Give a gap a purpose",
          "text": "The arch makes an opening of its own. Imagine changing the distance between these shapes without adding anything.",
          "image": "/assets/inspired-story-02-imagine.webp",
          "durationMs": 12000
        },
        {
          "label": "Connect",
          "title": "Leave room on the page",
          "text": "The blank sketchbook offers another kind of space. What one idea would you place there, leaving the rest open?",
          "image": "/assets/inspired-story-03-connect.webp",
          "durationMs": 12000
        },
        {
          "label": "Keep",
          "title": "Keep a useful pause",
          "text": "Notice the clear paper around the painted forms. Choose one place where a gap could belong in your own arrangement.",
          "image": "/assets/inspired-story-04-keep.webp",
          "durationMs": 12000
        }
      ]
    },
    {
      "activityId": "feeling-inspired-05",
      "mood": "inspired",
      "stages": [
        {
          "label": "Notice",
          "title": "Begin with a texture",
          "text": "Compare the lavender fabric with the smooth glass and glazed ceramic. Which texture would you describe first?",
          "image": "/assets/inspired-story-01-notice.webp",
          "durationMs": 12000
        },
        {
          "label": "Imagine",
          "title": "Try an unexpected material pair",
          "text": "Rough terracotta meets translucent glass and paper. Choose two materials that you would like to see together.",
          "image": "/assets/inspired-story-02-imagine.webp",
          "durationMs": 12000
        },
        {
          "label": "Connect",
          "title": "Describe the touch in words",
          "text": "Imagine writing two texture words in the sketchbook, or drawing marks for them: soft and rough, smooth and folded.",
          "image": "/assets/inspired-story-03-connect.webp",
          "durationMs": 12000
        },
        {
          "label": "Keep",
          "title": "Keep two textures together",
          "text": "The paper, painted edges and nearby cloth offer another pairing. Keep two words for a material combination of your own.",
          "image": "/assets/inspired-story-04-keep.webp",
          "durationMs": 12000
        }
      ]
    },
    {
      "activityId": "feeling-inspired-06",
      "mood": "inspired",
      "stages": [
        {
          "label": "Notice",
          "title": "Find a welcoming shape",
          "text": "The open curve of the burgundy ceramic leaves a space at its centre. What shape would you find welcoming?",
          "image": "/assets/inspired-story-01-notice.webp",
          "durationMs": 12000
        },
        {
          "label": "Imagine",
          "title": "Imagine a small invitation",
          "text": "An arch, a sphere and folded paper make a small scene. Imagine one detail greeting you at a doorway or on a desk.",
          "image": "/assets/inspired-story-02-imagine.webp",
          "durationMs": 12000
        },
        {
          "label": "Connect",
          "title": "Give the beginning a place",
          "text": "The studio chair faces an open sketchbook. What first small idea would you want waiting on that page?",
          "image": "/assets/inspired-story-03-connect.webp",
          "durationMs": 12000
        },
        {
          "label": "Keep",
          "title": "Keep one welcome detail",
          "text": "Choose a colour or curve from the study for your imagined welcome. Finish the phrase: a good beginning could look like…",
          "image": "/assets/inspired-story-04-keep.webp",
          "durationMs": 12000
        }
      ]
    },
    {
      "activityId": "feeling-inspired-07",
      "mood": "inspired",
      "stages": [
        {
          "label": "Notice",
          "title": "Let a colour lead",
          "text": "Burgundy, lavender and blue-green glass make a quiet palette. Which colour would you borrow first?",
          "image": "/assets/inspired-story-01-notice.webp",
          "durationMs": 12000
        },
        {
          "label": "Imagine",
          "title": "Find an unexpected echo",
          "text": "The terracotta arch introduces a warmer neighbour. Which colour combination surprises you a little?",
          "image": "/assets/inspired-story-02-imagine.webp",
          "durationMs": 12000
        },
        {
          "label": "Connect",
          "title": "Imagine the next appearance",
          "text": "Picture the chosen colour on something small: a postcard, a sketchbook margin or a painted edge.",
          "image": "/assets/inspired-story-03-connect.webp",
          "durationMs": 12000
        },
        {
          "label": "Keep",
          "title": "Give the palette a name",
          "text": "Give your imagined palette a name. It can be a place, a season, or two ordinary words of your own.",
          "image": "/assets/inspired-story-04-keep.webp",
          "durationMs": 12000
        }
      ]
    },
    {
      "activityId": "feeling-inspired-08",
      "mood": "inspired",
      "stages": [
        {
          "label": "Notice",
          "title": "Imagine a first story",
          "text": "The fabric, glass and ceramic could belong to a studio or a carefully arranged shelf. Which story would you tell first?",
          "image": "/assets/inspired-story-01-notice.webp",
          "durationMs": 12000
        },
        {
          "label": "Imagine",
          "title": "Let the scene change its story",
          "text": "The arch and sphere make the scene more abstract. Imagine these same colours as a landscape, a room or a small sculpture.",
          "image": "/assets/inspired-story-02-imagine.webp",
          "durationMs": 12000
        },
        {
          "label": "Connect",
          "title": "Picture two possible pages",
          "text": "Picture two sketches in the open book: one for each story. Which object or colour would appear in both?",
          "image": "/assets/inspired-story-03-connect.webp",
          "durationMs": 12000
        },
        {
          "label": "Keep",
          "title": "Hold both possibilities",
          "text": "The painted forms leave their subject open. Give your two ideas a sentence each; neither has to become the final version.",
          "image": "/assets/inspired-story-04-keep.webp",
          "durationMs": 12000
        }
      ]
    },
    {
      "activityId": "feeling-inspired-09",
      "mood": "inspired",
      "stages": [
        {
          "label": "Notice",
          "title": "Notice an ordinary object",
          "text": "A glass sits beside fabric and curved ceramic. Which everyday object would you enjoy looking at in a clear space?",
          "image": "/assets/inspired-story-01-notice.webp",
          "durationMs": 12000
        },
        {
          "label": "Imagine",
          "title": "Look at what makes it worth showing",
          "text": "The translucent panel, paper and clay have different edges. What ordinary material could you place among them?",
          "image": "/assets/inspired-story-02-imagine.webp",
          "durationMs": 12000
        },
        {
          "label": "Connect",
          "title": "Imagine one useful display",
          "text": "Imagine sketching just that one object on the page. What shape, colour or memory makes it worth drawing?",
          "image": "/assets/inspired-story-03-connect.webp",
          "durationMs": 12000
        },
        {
          "label": "Keep",
          "title": "Choose what deserves the view",
          "text": "Choose one object and one reason to give it a place in view. A small colour study can be a way to explore that choice.",
          "image": "/assets/inspired-story-04-keep.webp",
          "durationMs": 12000
        }
      ]
    },
    {
      "activityId": "feeling-inspired-10",
      "mood": "inspired",
      "stages": [
        {
          "label": "Notice",
          "title": "Find a sentence in a detail",
          "text": "Look at one detail: the folded fabric, the glass rim or the burgundy curve. What first sentence could begin there?",
          "image": "/assets/inspired-story-01-notice.webp",
          "durationMs": 12000
        },
        {
          "label": "Imagine",
          "title": "Let two objects start a thought",
          "text": "Put the arch and sphere into an imagined scene. What might happen if these shapes were characters, places or objects in a story?",
          "image": "/assets/inspired-story-02-imagine.webp",
          "durationMs": 12000
        },
        {
          "label": "Connect",
          "title": "Imagine the unfinished page",
          "text": "The studio notebook is open and unmarked. Picture writing one line without deciding what the whole piece will become.",
          "image": "/assets/inspired-story-03-connect.webp",
          "durationMs": 12000
        },
        {
          "label": "Keep",
          "title": "Keep the next line small",
          "text": "Keep a phrase, a question or a title suggested by the colours and curved line. The rest of the page can wait.",
          "image": "/assets/inspired-story-04-keep.webp",
          "durationMs": 12000
        }
      ]
    },
    {
      "activityId": "feeling-energized-01",
      "mood": "energized",
      "stages": [
        {
          "label": "Choose",
          "title": "Choose one useful message",
          "text": "Think of a message you have been meaning to write. Choose one person and one clear purpose.",
          "image": "/assets/energized-story-01-dawn.webp",
          "durationMs": 10000
        },
        {
          "label": "Prepare",
          "title": "Prepare a few words",
          "text": "Open a blank note and write the main point you want to share. Leave the address and sending decision for later.",
          "image": "/assets/energized-story-02-ready-desk.webp",
          "durationMs": 10000
        },
        {
          "label": "Shift",
          "title": "Shift into your first step",
          "text": "Try a small comfortable movement, seated or standing—or stay still and picture your first step. Choose what works for you.",
          "image": "/assets/energized-story-03-garden-path.webp",
          "durationMs": 10000
        },
        {
          "label": "Begin",
          "title": "Write the opening line",
          "text": "Write one greeting and your first sentence. You can pause before finishing or sending anything.",
          "image": "/assets/energized-story-04-first-mark.webp",
          "durationMs": 10000
        }
      ]
    },
    {
      "activityId": "feeling-energized-02",
      "mood": "energized",
      "stages": [
        {
          "label": "Choose",
          "title": "Choose one clear surface",
          "text": "Pick one small surface you would like to use: a desk corner, shelf or table.",
          "image": "/assets/energized-story-01-dawn.webp",
          "durationMs": 10000
        },
        {
          "label": "Prepare",
          "title": "Decide what belongs there",
          "text": "Name the activity that needs this space. Identify one item to keep and one to put in its proper place.",
          "image": "/assets/energized-story-02-ready-desk.webp",
          "durationMs": 10000
        },
        {
          "label": "Shift",
          "title": "Shift into your first step",
          "text": "Try a small comfortable movement, seated or standing—or stay still and picture your first step. Choose what works for you.",
          "image": "/assets/energized-story-03-garden-path.webp",
          "durationMs": 10000
        },
        {
          "label": "Begin",
          "title": "Move just one item",
          "text": "If practical, put that single item away. You can also write which item you will move and when.",
          "image": "/assets/energized-story-04-first-mark.webp",
          "durationMs": 10000
        }
      ]
    },
    {
      "activityId": "feeling-energized-03",
      "mood": "energized",
      "stages": [
        {
          "label": "Choose",
          "title": "Choose a project to begin",
          "text": "Think of a small project with a beginning you can name. Leave the whole outcome for another day.",
          "image": "/assets/energized-story-01-dawn.webp",
          "durationMs": 10000
        },
        {
          "label": "Prepare",
          "title": "Give the next step a line",
          "text": "Write only the next action in a notebook. A title, a file name or one material can be enough.",
          "image": "/assets/energized-story-02-ready-desk.webp",
          "durationMs": 10000
        },
        {
          "label": "Shift",
          "title": "Shift into your first step",
          "text": "Try a small comfortable movement, seated or standing—or stay still and picture your first step. Choose what works for you.",
          "image": "/assets/energized-story-03-garden-path.webp",
          "durationMs": 10000
        },
        {
          "label": "Begin",
          "title": "Make the first line",
          "text": "Write the heading or open the relevant file. If later is better, name a time and place to start.",
          "image": "/assets/energized-story-04-first-mark.webp",
          "durationMs": 10000
        }
      ]
    },
    {
      "activityId": "feeling-energized-04",
      "mood": "energized",
      "stages": [
        {
          "label": "Choose",
          "title": "Choose a small colour idea",
          "text": "Pick two colours you would like to try together in a card, drawing or room detail.",
          "image": "/assets/energized-story-01-dawn.webp",
          "durationMs": 10000
        },
        {
          "label": "Prepare",
          "title": "Give the pair a place",
          "text": "Find a blank page and one pencil, or open a note. Name the object where your colours might belong.",
          "image": "/assets/energized-story-02-ready-desk.webp",
          "durationMs": 10000
        },
        {
          "label": "Shift",
          "title": "Shift into your first step",
          "text": "Try a small comfortable movement, seated or standing—or stay still and picture your first step. Choose what works for you.",
          "image": "/assets/energized-story-03-garden-path.webp",
          "durationMs": 10000
        },
        {
          "label": "Begin",
          "title": "Record the colour pair",
          "text": "Write both colour names and draw one simple shape for the object. The rest can wait.",
          "image": "/assets/energized-story-04-first-mark.webp",
          "durationMs": 10000
        }
      ]
    },
    {
      "activityId": "feeling-energized-05",
      "mood": "energized",
      "stages": [
        {
          "label": "Choose",
          "title": "Choose something to learn",
          "text": "Choose one question you want to explore, without deciding how much you must learn today.",
          "image": "/assets/energized-story-01-dawn.webp",
          "durationMs": 10000
        },
        {
          "label": "Prepare",
          "title": "Prepare a place for the question",
          "text": "Set a notebook or note within reach. Write the question as clearly as you can.",
          "image": "/assets/energized-story-02-ready-desk.webp",
          "durationMs": 10000
        },
        {
          "label": "Shift",
          "title": "Shift into your first step",
          "text": "Try a small comfortable movement, seated or standing—or stay still and picture your first step. Choose what works for you.",
          "image": "/assets/energized-story-03-garden-path.webp",
          "durationMs": 10000
        },
        {
          "label": "Begin",
          "title": "Open one useful source",
          "text": "Choose a suitable reference and read its first relevant paragraph. You can also note where to look later.",
          "image": "/assets/energized-story-04-first-mark.webp",
          "durationMs": 10000
        }
      ]
    },
    {
      "activityId": "feeling-energized-06",
      "mood": "energized",
      "stages": [
        {
          "label": "Choose",
          "title": "Choose a useful pairing",
          "text": "Think of two familiar materials you could combine in a small creative project: paper and pencil, fabric and thread, or another pair.",
          "image": "/assets/energized-story-01-dawn.webp",
          "durationMs": 10000
        },
        {
          "label": "Prepare",
          "title": "Name the first experiment",
          "text": "Choose one small thing to try with the pair. Set out only what that first attempt needs.",
          "image": "/assets/energized-story-02-ready-desk.webp",
          "durationMs": 10000
        },
        {
          "label": "Shift",
          "title": "Shift into your first step",
          "text": "Try a small comfortable movement, seated or standing—or stay still and picture your first step. Choose what works for you.",
          "image": "/assets/energized-story-03-garden-path.webp",
          "durationMs": 10000
        },
        {
          "label": "Begin",
          "title": "Make one small sample",
          "text": "Draw a line, fold a piece of paper, or write a plan for the sample. There is no need to finish the project.",
          "image": "/assets/energized-story-04-first-mark.webp",
          "durationMs": 10000
        }
      ]
    },
    {
      "activityId": "feeling-energized-07",
      "mood": "energized",
      "stages": [
        {
          "label": "Choose",
          "title": "Choose an afternoon project",
          "text": "Think of something you would enjoy starting when you have a little time: a sketch, a letter or a simple repair plan.",
          "image": "/assets/energized-story-01-dawn.webp",
          "durationMs": 10000
        },
        {
          "label": "Prepare",
          "title": "Name the first tool",
          "text": "Choose one suitable tool and a safe place to use it. If materials are missing, make a short list instead.",
          "image": "/assets/energized-story-02-ready-desk.webp",
          "durationMs": 10000
        },
        {
          "label": "Shift",
          "title": "Shift into your first step",
          "text": "Try a small comfortable movement, seated or standing—or stay still and picture your first step. Choose what works for you.",
          "image": "/assets/energized-story-03-garden-path.webp",
          "durationMs": 10000
        },
        {
          "label": "Begin",
          "title": "Set up one beginning",
          "text": "Put the tool within reach or write the first materials item. You can name when and where you will return.",
          "image": "/assets/energized-story-04-first-mark.webp",
          "durationMs": 10000
        }
      ]
    },
    {
      "activityId": "feeling-energized-08",
      "mood": "energized",
      "stages": [
        {
          "label": "Choose",
          "title": "Choose a conversation to start",
          "text": "Think of a person you would like to catch up with and one ordinary thing you would enjoy asking about.",
          "image": "/assets/energized-story-01-dawn.webp",
          "durationMs": 10000
        },
        {
          "label": "Prepare",
          "title": "Prepare one open question",
          "text": "Write a question that leaves room for their answer. You can keep it in a note until a suitable moment.",
          "image": "/assets/energized-story-02-ready-desk.webp",
          "durationMs": 10000
        },
        {
          "label": "Shift",
          "title": "Shift into your first step",
          "text": "Try a small comfortable movement, seated or standing—or stay still and picture your first step. Choose what works for you.",
          "image": "/assets/energized-story-03-garden-path.webp",
          "durationMs": 10000
        },
        {
          "label": "Begin",
          "title": "Write the invitation",
          "text": "Draft a short opening line. Choose whether and when to use it; nothing is sent from this activity.",
          "image": "/assets/energized-story-04-first-mark.webp",
          "durationMs": 10000
        }
      ]
    },
    {
      "activityId": "feeling-energized-09",
      "mood": "energized",
      "stages": [
        {
          "label": "Choose",
          "title": "Choose one preparation for tomorrow",
          "text": "Pick one ordinary thing that would be useful to have ready: a bag, a note or a materials list.",
          "image": "/assets/energized-story-01-dawn.webp",
          "durationMs": 10000
        },
        {
          "label": "Prepare",
          "title": "Check what is needed",
          "text": "Name one item to find and where it belongs. Keep the preparation small enough to do or plan comfortably.",
          "image": "/assets/energized-story-02-ready-desk.webp",
          "durationMs": 10000
        },
        {
          "label": "Shift",
          "title": "Shift into your first step",
          "text": "Try a small comfortable movement, seated or standing—or stay still and picture your first step. Choose what works for you.",
          "image": "/assets/energized-story-03-garden-path.webp",
          "durationMs": 10000
        },
        {
          "label": "Begin",
          "title": "Place or list one item",
          "text": "Put that item in its place if convenient, or write a reminder with a time and location for doing it later.",
          "image": "/assets/energized-story-04-first-mark.webp",
          "durationMs": 10000
        }
      ]
    },
    {
      "activityId": "feeling-energized-10",
      "mood": "energized",
      "stages": [
        {
          "label": "Choose",
          "title": "Choose a project with layers",
          "text": "Think of a task that can be divided into small parts: a drawing, a document or a room arrangement.",
          "image": "/assets/energized-story-01-dawn.webp",
          "durationMs": 10000
        },
        {
          "label": "Prepare",
          "title": "Name only the first layer",
          "text": "Write one component of the task. Avoid turning this moment into a long checklist.",
          "image": "/assets/energized-story-02-ready-desk.webp",
          "durationMs": 10000
        },
        {
          "label": "Shift",
          "title": "Shift into your first step",
          "text": "Try a small comfortable movement, seated or standing—or stay still and picture your first step. Choose what works for you.",
          "image": "/assets/energized-story-03-garden-path.webp",
          "durationMs": 10000
        },
        {
          "label": "Begin",
          "title": "Begin one component",
          "text": "Write a heading, gather one material or make a first sketch. Choose whether to continue after that.",
          "image": "/assets/energized-story-04-first-mark.webp",
          "durationMs": 10000
        }
      ]
    }
  ]
}
